module.exports = __webpack_public_path__ + "img/24.6fef4d28.jpg";